import { FilterConsts } from '../dependencies';

const { ORDER_TYPE, OrderSigns } = FilterConsts;

export const listOrder = OrderSigns[ORDER_TYPE.desc];
export const listOrderBy = 'startAt';
